<template>
  <div class="SearchGoodsDialog" @click="clicks">
    <el-dialog title="商品选择" width="1000px" :visible.sync="visible" @close="clearData" :show="show">
      <div class="content_box">
        <div class="content_top">
          <el-input
            v-model="searchText"
            size="mini"
            placeholder="输入名称/编号"
            ref="SearchGoods"
            id="Search"
            class="search_input"
            @keyup.up.native="UpArrow"
            @keyup.down.native="DwArrow"
            @keyup.enter.native="enterArrow"
          ></el-input>
          <!-- <el-checkbox v-model="showLeve" style="margin-left:10px;"  @change="checkChange">显示层级结构</el-checkbox> -->
          <el-button type="warning" size="mini" class="search_btn" @click="searchClick">查询</el-button>
        </div>
        <div class="content_infor_box">
          <div class="tree_sty" id="box">
            <Tree :treeData="treeData" @clickTree="clickTree" />
          </div>
          <div class="drage_box" @mousedown.stop.prevent="mouseDown"></div>
          <GoodsTable
            ref="footer"
            class="right"
            max="300"
            :configData="configData"
            :tableData="tableData"
            @rowdblclick="rowdblclick"
            @SelectionChange="SelectionChange"
          />
        </div>
      </div>
      <div class="content_footer_box">
        <!-- 分页 -->
        <el-pagination
          style="width:70%;display: flex;justify-content: center; "
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20,50,100]"
          :page-size="pageSize"
          layout="total, sizes,prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
        <div class="content_btn_box">
          <el-button type="primary" size="mini" style="display:block" @click="saveGoods">确定</el-button>
          <el-button style="display:block" size="mini" @click="$emit('update:show', false)">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>  

<script>
import tool from "@/utils/tool"; //本地缓存存取

let configData = [
  { label: "商品名称", field: "FullName" },
  { label: "商品编号", field: "BaseCode" },
  { label: "可用库存", field: "AQty" },
  { label: "单位", field: "UnitName" },
  { label: "规格", field: "Standards" },
  { label: "型号", field: "Model" },
  { label: "产地", field: "ProArea" }
];
export default {
  data() {
    return {
      Identify:0,//标志是请求getall接口还是search接口，0：getall，1：search
      dw: 0, // 鼠标点击时记录需要拉长前的长或者宽
      dx: 0, // 鼠标点击时记录需要拉长前的屏幕距离宽或者高
      visible: this.show,
      searchText: this.textname, // this.$attrs.textname, //"", //收索内容
      // showLeve:true,//是否显示层级
      treeData: [], //树状图数据
      configData: configData, //表格配置项
      tableData: [], //table表格数据
      selectData: [], //选中数据
      // 分页
      currentPage: 1, //当前页码
      total: 0, //总页数
      pageSize: 10 //每页显示数量
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    fieldData: String,
    textname: {
      type: String,
      default: ""
    },
    pargam: [Object]
  },
  methods: {
    clicks() {
      // this.$refs.SearchGoods.$refs.input.focus();
      //  document.getElementById("Search").focus()
    },
    enterArrow() {
      this.$refs.footer.enterArrow(2);
    },
    childAction() {
      // console.log("我想执行一些操作");
      this.$refs.SearchGoods.$refs.input.focus();
      this.$refs.footer.$refs.xTable1.setCurrentRow(
        this.$refs.footer.tableData[0]
      );
    },
    UpArrow() {
      this.$refs.footer.highlightcurren(2);
    },
    DwArrow() {
      this.$refs.footer.highlightcurrens(1);
    },
    // 请求树状图数据
    InitTree() {
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        Stoped: this.pargam.Stoped //是否数据的状态 0启用 1停用  不传两者都有
      };
      // console.log(params);
      this.request
        .post("/index/Goods/getlist", { jparams: JSON.stringify(params) })
        .then(res => {
          // 接收后端发送回来的数据
          // console.log(res)
          this.treeData = res.tree;
        })
        .catch(err => {
          //   console.log(err);
        });
    },
    // 请求table表格数据
    InitTable() {
      let invid;
      if (this.pargam.InvId == undefined) {
        invid = 0;
      } else {
        invid = this.pargam.InvId;
      }
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        pagesize: this.pageSize,
        pagenum: this.currentPage,
        type: 1, //显示末端数据
        KtypeId: this.$attrs.warehouseVal1.KtypeId, //仓库ID
        BtypeId: this.pargam.BtypeId, //客户&供应商ID
        BuySale: this.pargam.BuySale, //0销售 1采购   控制显示销售或者采购的价格KFlag为1才生效
        KFlag: this.pargam.KFlag, //是否查询库存&价格信息 0不查询 1查询
        Model: this.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
        Stoped: this.pargam.Stoped, //是否数据的状态 0启用 1停用  不传两者都有
        InvId: invid // 盘点单 InvID没有投就传l
      };
      // console.log('++++++++++++',this.pargam);
      this.request
        .post("/index/Goods/getall", { jparams: JSON.stringify(params) })
        .then(res => {
          // console.log(res);
          // 接收后端发送回来的数据
          this.total = res.count;
          this.tableData = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 条件查询table数据
    QueryTable(ParentId) {
      let invid;
      if (this.pargam.InvId == undefined) {
        invid = 0;
      } else {
        invid = this.pargam.InvId;
      }
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        IsDir: 0, //0数据 1目录
        pagesize: this.pageSize,
        pagenum: this.currentPage,
        Keywords: this.searchText,
        ParentNo: ParentId,
        // ...this.jparam
        KtypeId: this.$attrs.warehouseVal1.KtypeId, // this.pargam.KtypeId, //仓库ID
        BtypeId: this.pargam.BtypeId, //客户&供应商ID
        BuySale: this.pargam.BuySale, //0销售 1采购   控制显示销售或者采购的价格KFlag为1才生效
        KFlag: this.pargam.KFlag, //是否查询库存&价格信息 0不查询 1查询
        Model: this.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
        Stoped: this.pargam.Stoped, //是否数据的状态 0启用 1停用  不传两者都有
        InvId: invid // 盘点单 InvID没有投就传l
      };
      // console.log(params);
      this.request
        .post("/index/Goods/search", { jparams: JSON.stringify(params) })
        .then(res => {
          // 接收后端发送回来的数据
          // console.log('------->',res)
          this.total = res.count;
          this.tableData = res.data;
          // console.log(this.tableData)
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 当前页显示条数发生变化时
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      if (this.Identify==0) {
        this.InitTable();
      }else{
        this.QueryTable()
      }
    },
    // 当前页发生变化时
    handleCurrentChange(val) {
      // console.log(val);
      this.currentPage = val;
      if (this.Identify==0) {
        this.InitTable();
      }else{
        this.QueryTable()
      }
    },
    // 点击收索按钮
    searchClick() {
      this.Identify = 1;//把标志改为1.请求search接口
      this.currentPage = 1;
      this.QueryTable();
      // let invid;
      // if (this.pargam.InvId == "" || this.pargam.InvId == undefined) {
      //   invid = 0;
      // } else {
      //   invid = this.pargam.InvId;
      // }
      // let params = {
      //   user_id: tool.getLocal("userid"),
      //   session_id: tool.getLocal("sessionid"),
      //   Keywords: this.searchText,
      //   IsDir: 0, //0数据 1目录
      //   pagesize: 10,
      //   pagenum: 1,
      //   // ...this.jparam
      //   KtypeId: this.$attrs.warehouseVal1.KtypeId, //this.pargam.KtypeId, //仓库ID
      //   BtypeId: this.pargam.BtypeId, //客户&供应商ID
      //   BuySale: this.pargam.BuySale, //0销售 1采购   控制显示销售或者采购的价格KFlag为1才生效
      //   KFlag: this.pargam.KFlag, //是否查询库存&价格信息 0不查询 1查询
      //   Model: this.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
      //   Stoped: this.pargam.Stoped, //是否数据的状态 0启用 1停用  不传两者都有
      //   InvId: invid
      // };
      // // console.log(params);
      // this.request
      //   .post("/index/Goods/search", { jparams: JSON.stringify(params) })
      //   .then(res => {
      //     // 接收后端发送回来的数据
      //     // console.log(res);
      //     this.total = res.count;
      //     this.tableData = res.data;
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    // 点击table头部图标返回上一级
    clickIcon() {
      // this.InitTable();
    },
    // 双击table行元素
    rowdblclick(data) {
      this.$emit("chooseGoodsBack", data);
      this.clearData();
    },
    // table表格select选项框改变触发
    SelectionChange(data) {
      // console.log(data);
      this.selectData = data;
    },
    // 点击树状图节点
    clickTree(data) {
      // console.log(data);
      if (data.id == 0) {
        this.Identify = 0;//把标志改为0.getall
        this.currentPage = 1;
        this.InitTable();
      } else {
        this.Identify = 1;//把标志改为1.请求search接口
        this.currentPage = 1;
        this.QueryTable(data.id);
      }
    },
    // 点击确定返回数据
    saveGoods() {
      if (this.selectData.length != 0) {
        this.$emit("chooseGoodsBack", this.selectData);
        this.clearData();
      } else {
        this.$message({
          message: "你未选择任何商品",
          type: "warning"
        });
      }
    },
    // 关闭弹出框并且清空数据
    clearData() {
      this.searchText = "";
      this.InitTree();
      this.InitTable();
      this.$emit("update:show", false);
    },
    // 拖拽改变宽度
    mouseDown(ev) {
      document.documentElement.addEventListener(
        "mousemove",
        this.mouse_move,
        true
      );
      const tagBox = document.getElementById("box");
      const iEvent = ev || event;
      this.dx = iEvent.clientX;
      this.dw = tagBox.offsetWidth;
      // if (iEvent.clientX > tagBox.offsetLeft + 10) {
      //     this.resizing = 'left';
      // }
    },
    mouse_move(ev) {
      const tagBox = document.getElementById("box");
      const iEvent = ev || event;
      // console.log(tagBox.style.width);
      if (tagBox.style.width >= 600) {
        tagBox.style.width = "600px";
      }
      tagBox.style.width = `${this.dw + (iEvent.clientX - this.dx)}px`;
    },
    mouseUp() {
      document.documentElement.removeEventListener(
        "mousemove",
        this.mouse_move,
        true
      );
    }
  },
  created() {
    // this.visible = false
    // document.getElementById("SearchGoodsDialog12").focus();
  },
  watch: {
    show() {
      this.visible = this.show;
      if (this.visible == true) {
      }
    },
    // 观察传递参数
    pargam: {
      handler(newValue, oldValue) {
        this.InitTable();
      },
      deep: true
    },
    textname: {
      handler(newVal, oldVal) {
        this.searchText = newVal;
        this.searchClick()
      }
    }
  },

  // 创建生命周期钩子函数
  mounted() {
    this.$on("foot", val => {
      this.childAction();
    });
    document.documentElement.addEventListener("mouseup", this.mouseUp, true);
    // 初始化数据
    this.InitTree();
    this.InitTable();
  }
};
</script>

<style lang="less" scoped>
.SearchGoodsDialog {
  .el-dialog__header {
    background: rebeccapurple;
    // background: #4990d7;
    padding: 10px 10px 0;
    .el-dialog__title {
      color: #fff;
      font-size: 14px;
    }
    .el-dialog__headerbtn {
      top: 10px;
      right: 10px;
      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
      }
    }
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .content_box {
    .content_top {
      width: 100%;
      height: 40px;
      display: -webkit-box !important;
      display: box !important;
      position: relative;
      -webkit-box-align: center;
      box-align: center;
      .search_input {
        display: block;
        width: 200px;
      }
      .search_btn {
        margin-left: 10px;
      }
    }
    .content_infor_box {
      width: 100%;
      height: 300px;
      display: -webkit-box !important;
      display: box !important;
      position: relative;
      .tree_sty {
        min-width: 200px;
        max-width: 890px;
        height: 300px;
      }
      .drage_box {
        width: 10px;
        height: 100%;
        cursor: e-resize !important;
      }
      .right {
        height: 100%;
        position: relative;
        -webkit-box-flex: 1;
        box-flex: 1;
      }
    }
  }
  .content_footer_box {
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    -webkit-box-align: center;
    box-align: center;
    -webkit-box-pack: justify;
    box-pack: justify;
    margin: 10px auto 0;
    .content_btn_box {
      display: -webkit-box !important;
      display: box !important;
      position: relative;
      -webkit-box-align: center;
      box-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/SearchGoodsDialog/SearchGoodsDialog.vue